import { SimpleTreeView } from '@mui/x-tree-view/SimpleTreeView';
import { TreeItem } from '@mui/x-tree-view/TreeItem';
import { closestCenter, DndContext, DragOverlay, PointerSensor, useDraggable, useDroppable, useSensor, useSensors } from '@dnd-kit/core'
import { SortableContext } from '@dnd-kit/sortable'
import { IconButton, Typography } from '@mui/material';
import { MoreVert } from '@mui/icons-material'

export interface SidebarProps {
    subviews?: any[]
    onSelect?: (subview: any) => void;
    onEdit?: (subview: any) => void;
    onContext?: (e: any, subview: any) => void;
}

const DraggableTreeItem = (props) => {
    const { itemId, label, children } = props;

    const {
        active,
        attributes,
        listeners,
        setNodeRef: setDraggableRef,
        transform,
        isDragging
    } = useDraggable({
        id: itemId,
    });

    const { setNodeRef: setDroppableRef, isOver } = useDroppable({ id: itemId });

    const combinedRef = (node) => {
        setDraggableRef(node);
        setDroppableRef(node);
    };


    const style = {
        display: 'flex',
        alignItems: 'center',
        transform: transform
            ? `translate(${transform.x}px, ${transform.y}px)`
            : undefined,
        borderBottom: (isOver && active.id != itemId) ? '1px solid blue' : undefined
    };

    return (
        <div ref={combinedRef} >
            <TreeItem sx={{
                '.MuiIconButton-root': {
                    opacity: 0,
                    pointerEvents: 'none'
                },
                '& .MuiTreeItem-content:hover .MuiIconButton-root': {
                    opacity: 1,
                    pointerEvents: 'all'
                }
            }} itemId={props.itemId} onClick={() => !isDragging && props.onClick()}  label={(
                <div style={style} {...listeners} {...attributes}>
                    <Typography sx={{width: '100%'}}>{props.label}</Typography>
                    <IconButton onClick={props.onEdit} size='small'><MoreVert fontSize='inherit' /></IconButton>
                </div>
            )} >
                {children}
            </TreeItem>
        </div>
    );
};


export const Sidebar: React.FC<SidebarProps> = (props) => {

    const sensors = useSensors(
        useSensor(PointerSensor, {
          activationConstraint: {
            distance: 8,
          },
        })
      )
      
    const renderSubview = (subview: any) => {

        return (
            <DraggableTreeItem
                onContextMenu={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    props.onContext?.(e, subview)
                }}
                onEdit={() => {props.onEdit?.(subview)}}
                onClick={() => props.onSelect?.(subview)}
                key={subview.id}
                itemId={subview.id}
                label={subview.name}>
                {subview?.subviews?.map(renderSubview)}
            </DraggableTreeItem>
        )
    }
    return (
        <DndContext
            sensors={sensors}
            collisionDetection={closestCenter}
            onDragOver={(event) => {
            }}
            onDragEnd={(event) => {
                const { active, over } = event;
                if (over && active.id !== over.id) {
                    // handle tree rearrangement logic here
                    console.log(`Move ${active.id} into ${over.id}`);
                }
            }}>
            <SimpleTreeView >
                {props.subviews?.map(renderSubview)}
            </SimpleTreeView>
        </DndContext>)
}
